/* Ressa Palace: phone helpers. */
(function () {
  if (window.RessaPalaceMobile) return;
  window.RessaPalaceMobile = true;
  var phone = function () { return window.matchMedia('(max-width: 749px)').matches; };
  var smooth = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  function scrollToEl(el, offset) {
    var y = el.getBoundingClientRect().top + window.pageYOffset - (offset || 80);
    window.scrollTo({ top: y, behavior: smooth });
  }
  // Counter: keep the next question in view, then jump to the sarees once they are laid out.
  function watchCounter(root) {
    var cards = root.querySelector('[data-cards]'), opts = root.querySelector('[data-options]');
    if (!cards || cards.__rpm) return; cards.__rpm = true;
    new MutationObserver(function () {
      if (phone() && cards.children.length) setTimeout(function () { scrollToEl(cards, 90); }, 150);
    }).observe(cards, { childList: true });
    if (opts) new MutationObserver(function () {
      if (!phone() || !opts.children.length) return;
      var r = opts.getBoundingClientRect();
      if (r.bottom > window.innerHeight - 20) scrollToEl(opts, window.innerHeight * 0.45);
    }).observe(opts, { childList: true });
  }
  // Tap anywhere on a folded saree to unfold it.
  document.addEventListener('click', function (e) {
    var card = e.target.closest('.rp-fold');
    if (!card || card.classList.contains('is-open') || e.target.closest('a,button')) return;
    var b = card.querySelector('[data-rp-unfold]'); if (b) b.click();
  });
  // Close-up lens: a tap moves the zoom to that spot.
  document.addEventListener('pointerdown', function (e) {
    var el = e.target.closest('[data-rp-lens]'); if (!el) return;
    var r = el.getBoundingClientRect();
    el.style.backgroundPosition = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
  });
  // Sticky add-to-bag bar while the main buttons are off screen.
  function watchSticky(bar) {
    if (bar.__rpm) return; bar.__rpm = true;
    var target = document.getElementById(bar.getAttribute('data-for'));
    if (!target) return;
    var ticking = false;
    function check() {
      ticking = false;
      var past = target.getBoundingClientRect().bottom < 0;
      if (past !== bar.classList.contains('is-on')) {
        bar.classList.toggle('is-on', past);
        bar.setAttribute('aria-hidden', past ? 'false' : 'true');
      }
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
    check();
  }
  function init(scope) {
    (scope || document).querySelectorAll('[data-rp-counter]').forEach(watchCounter);
    (scope || document).querySelectorAll('[data-rp-sticky]').forEach(watchSticky);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
